export default __webpack_public_path__ + "static/media/login-header.07312dcc.png";